import { getHistoryState, PasswordResetCard } from "@indietabletop/appkit";
import { ViewContainer } from "../max-width-container";
import { MobileNavLayout } from "../mobile-nav-layout";

export function ResetPasswordPage() {
  return (
    <MobileNavLayout title="Login">
      <ViewContainer padding="small">
        <PasswordResetCard defaultValues={{ email: getHistoryState()?.emailValue }} />
      </ViewContainer>
    </MobileNavLayout>
  );
}
